export const RATE_APPROVE_PREVIEW = "RATE_APPROVE_PREVIEW"
export const RATE_APPROVE_UPDATE = "RATE_APPROVE_UPDATE"
export const RATE_APPROVE_UPDATE_ALL = "RATE_APPROVE_UPDATE_ALL"
export const RATE_APPROVE_VIEW_SUMMARY = "RATE_APPROVE_VIEW_SUMMARY"
export const RATE_APPROVE_VIEW_SUMMARY_DATASOURCE = "RATE_APPROVE_VIEW_SUMMARY_DATASOURCE"
export const RATE_APPROVE_DATASOURCE_SUCCESS = "RATE_APPROVE_DATASOURCE_SUCCESS"
export const RATE_APPROVE_PROCESS_SUCCESS = "RATE_APPROVE_PROCESS_SUCCESS"
export const RATE_APPROVE_PROCESS_RESET = "RATE_APPROVE_PROCESS_RESET"
export const RATE_APPROVE_RESET = "RATE_APPROVE_RESET"

export type ViewSummaryInputValueType = {
    summaryType: "booking" | "registration"
    id?: number | null
}

export interface RateApproveRequest {
    type: typeof RATE_APPROVE_PREVIEW
}

export interface RateApproveUpdate {
    type: typeof RATE_APPROVE_UPDATE,
    payload: any
}

export interface RateApproveUpdateAll {
    type: typeof RATE_APPROVE_UPDATE_ALL,
    payload?: any
}
export interface RateApproveProcessSuccess {
    type: typeof RATE_APPROVE_PROCESS_SUCCESS,
    payload: any
}
export interface RateApproveDataSourceSuccess {
    type: typeof RATE_APPROVE_DATASOURCE_SUCCESS,
    payload: any
}

export interface RateApproveViewSummary {
    type: typeof RATE_APPROVE_VIEW_SUMMARY,
    payload: ViewSummaryInputValueType
}

export interface RateApproveViewSummaryDataSource {
    type: typeof RATE_APPROVE_VIEW_SUMMARY_DATASOURCE,
    payload: any
}

export interface RateApproveProcessReset {
    type: typeof RATE_APPROVE_PROCESS_RESET
}
export interface RateApproveReset {
    type: typeof RATE_APPROVE_RESET
}


export type RateApproveAction =
    | RateApproveRequest
    | RateApproveUpdate
    | RateApproveUpdateAll
    | RateApproveProcessSuccess
    | RateApproveDataSourceSuccess
    | RateApproveViewSummary
    | RateApproveViewSummaryDataSource
    | RateApproveProcessReset
    | RateApproveReset
